export function createSlateContentFromGeneratedRichContent(
  content: GeneratedRichContent,
) {
  const nodes: Array<Record<string, unknown>> = [];

  content.paragraphs.forEach((paragraph) => {
    nodes.push({
      type: 'paragraph',
      children: [
        {
          text: paragraph,
        },
      ],
    });
  });

  if (content.bullets.length) {
    nodes.push({
      type: 'ul',
      children: content.bullets.map((bullet) => ({
        type: 'li',
        children: [
          {
            text: bullet,
          },
        ],
      })),
    });
  }

  if (!nodes.length) {
    nodes.push({
      type: 'paragraph',
      children: [
        {
          text: '',
        },
      ],
    });
  }

  return JSON.stringify(nodes);
}
